import React from 'react';
export const PublicPasswordContext = React.createContext();